import { v4 as uuid } from 'uuid';
export var serializePropertyNames = function serializePropertyNames(propertyNames) {
  if (Array.isArray(propertyNames)) {
    return propertyNames.map(function (propertyName) {
      return {
        id: uuid(),
        propertyName: propertyName
      };
    });
  }

  return [{
    id: uuid(),
    propertyName: propertyNames
  }];
};